export const RENDER_MODE_VALUES = ["premium_video", "motion_still", "freeze_choice", "static_insert"];
export const RenderMode = {
    PREMIUM_VIDEO: "premium_video",
    MOTION_STILL: "motion_still",
    FREEZE_CHOICE: "freeze_choice",
    STATIC_INSERT: "static_insert",
};
export const RENDER_MODE_LABELS = {
    [RenderMode.PREMIUM_VIDEO]: "Vidéo premium",
    [RenderMode.MOTION_STILL]: "Image animée",
    [RenderMode.FREEZE_CHOICE]: "Arrêt sur choix",
    [RenderMode.STATIC_INSERT]: "Insert fixe",
};
